import Cookies from 'js-cookie';


const getCsrfToken = () => {
  const cookieName = document.getElementById('csrf_cookie_name')?.value;
  return Cookies.get(cookieName);
};

export default getCsrfToken;
